<template>
    <card body-class="no-padding table-responsive">
        <table class="datatable table table-striped primary dataTable no-footer">
            <thead>
            <tr>
                <th v-for="(col, index) in columns" :class="{'sortable': col.sortable}" v-on:click="onHeaderClick(col)">
                    <span>{{ $t(col.label) }}</span>
                    <span v-if="orderColumn == col.id">
                        <i v-if="orderFilter.startsWith('-')" class="fa fa-arrow-up" aria-hidden="true"></i>
                        <i v-else class="fa fa-arrow-down" aria-hidden="true"></i>
                    </span>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in data">
                <template v-for="(col, index) in columns">
                    <td>
                        <slot name="default" v-bind:row="row" v-bind:col="col"></slot>
                    </td>
                </template>
            </tr>
            </tbody>
        </table>
        <template v-for="(row, index) in data">
            <card class="datalist pb-1">
                <div class="flex-row" v-for="(col, index) in columns">
                    <div class="col-xs-4">{{ $t(col.label) }}</div>
                    <div class="col-xs-8">
                        <slot name="default" v-bind:row="row" v-bind:col="col"></slot>
                    </div>
                </div>
            </card>
        </template>
    </card>
</template>

<script>
  import * as StatusBadge from '../StatusBadge'

  export default {
    name: 'DataTable',
    props: {
      columns: Array,
      data: Array,
    },
    data() {
      return {
        orderColumn: null,
        orderFilter: null,
      }
    },
    methods: {
      onHeaderClick(col) {
        if (col.sortable) {
          const sortkey = typeof col.sortkey === 'string' ? col.sortkey : col.id;

          if (sortkey === this.orderColumn) {
            this.orderFilter = (this.orderFilter.startsWith('-') ?  '' : '-') + this.orderColumn;
          } else {
            this.orderFilter = '-' + sortkey;
          }

          this.orderColumn = sortkey;
          this.$emit('refresh', 0, this.orderFilter);
        }
      },
    }
  }
</script>

<style scoped>
    .datalist {
        display: none;
    }
    @media (max-width: 640px) {
        .datatable {
            display: none;
         }
         .datalist {
             display: initial;
         }
    }
</style>
